import type { CompanyCertification, CompanyCertificationType, Location } from "@/graphql/codegen/graphql"

export enum CertificationDialogType {
  ADD_CERTIFICATION = "addCertification",
  EDIT_CERTIFICATION = "editCertification",
  HISTORIC_CERTIFICATES = "historicCertificates",
  POST_CREATION = "postCreation",
  CONFIRM_DELETE_ALL = "confirmDeleteAll",
  CONFIRM_DELETE_SELECTED = "confirmDeleteSelected",
}

export enum CertificationStatus {
  MORE_THAN = "MORE_THAN",
  LESS_THAN = "LESS_THAN",
  EXPIRED = "EXPIRED",
  NOT_FILED = "NOT_FILED",
}

export interface GroupedByCertificationType {
  certificationType: CompanyCertificationType
  locations: GroupedByLocation[]
}

export interface GroupedByLocation {
  location: Location
  certificates: CompanyCertification[]
}

export interface TransformedCertificationTableItem {
  location: Location
  current?: CompanyCertification
  upcoming?: CompanyCertification
}
